/* WanderHub theme JS */
(function () {
  // Reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '-60px' });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // Nav scroll state
  var nav = document.querySelector('[data-wh-nav]');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 24) nav.classList.add('wh-nav-scrolled');
      else nav.classList.remove('wh-nav-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile drawer
  document.querySelectorAll('[data-wh-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelector('[data-wh-drawer]').classList.remove('hidden');
    });
  });
  document.querySelectorAll('[data-wh-drawer-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelector('[data-wh-drawer]').classList.add('hidden');
    });
  });

  // Accordion (FAQ)
  document.querySelectorAll('[data-wh-acc-group]').forEach(function (group) {
    var items = group.querySelectorAll('.wh-acc');
    items.forEach(function (item, idx) {
      var btn = item.querySelector('[data-wh-acc-toggle]');
      if (!btn) return;
      if (idx === 0) item.setAttribute('open', 'true');
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('open') === 'true';
        items.forEach(function (i) { i.setAttribute('open', 'false'); });
        item.setAttribute('open', isOpen ? 'false' : 'true');
      });
    });
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-wh-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-wh-gallery-main]');
    g.querySelectorAll('[data-wh-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        g.querySelectorAll('[data-wh-thumb]').forEach(function (x) {
          //x.classList.remove('ring-2', 'ring-navy', 'ring-offset-2');
          x.style.borderColor = 'transparent';
          x.removeAttribute('aria-current');
        });
        //t.classList.add('ring-2', 'ring-navy', 'ring-offset-2');
        t.style.borderColor = '#0E1F29';
        t.setAttribute('aria-current', 'true');
      });
    });
  });
  
// Product gallery thumbnail arrows - Diana (UPDATED)
document.querySelectorAll('[data-wh-gallery]').forEach(function (g) {
  var thumbnailRow = g.querySelector('[data-wh-thumbnails]');
  var previousButton = g.querySelector('[data-wh-thumbnails-prev]');
  var nextButton = g.querySelector('[data-wh-thumbnails-next]');

  if (!thumbnailRow || !previousButton || !nextButton) return;

function getScrollAmount() {
  var firstThumbnail = thumbnailRow.querySelector('[data-wh-thumb]');
  if (!firstThumbnail) return 300;
  var gap = parseFloat(window.getComputedStyle(thumbnailRow).gap) || 0;
  
  // Scroll exactly 3 images on both mobile and desktop
  return (firstThumbnail.offsetWidth + gap) * 3;
}

  function updateButtonStates() {
    var maxScroll = thumbnailRow.scrollWidth - thumbnailRow.clientWidth;
    var currentScroll = thumbnailRow.scrollLeft;

    // Disable prev button at start
    previousButton.disabled = currentScroll <= 0;
    previousButton.style.opacity = currentScroll <= 0 ? '0.5' : '1';
    previousButton.style.cursor = currentScroll <= 0 ? 'not-allowed' : 'pointer';

    // Disable next button at end
    nextButton.disabled = currentScroll >= maxScroll - 10;
    nextButton.style.opacity = currentScroll >= maxScroll - 10 ? '0.5' : '1';
    nextButton.style.cursor = currentScroll >= maxScroll - 10 ? 'not-allowed' : 'pointer';
  }

  previousButton.addEventListener('click', function () {
    if (thumbnailRow.scrollLeft > 0) {
      thumbnailRow.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
      setTimeout(updateButtonStates, 300);
    }
  });

  nextButton.addEventListener('click', function () {
    var maxScroll = thumbnailRow.scrollWidth - thumbnailRow.clientWidth;
    if (thumbnailRow.scrollLeft < maxScroll) {
      thumbnailRow.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
      setTimeout(updateButtonStates, 300);
    }
  });

  // Check button states on load and when scrolling
  updateButtonStates();
  thumbnailRow.addEventListener('scroll', updateButtonStates);
});

// Swipe main product image on mobile - Diana
document.querySelectorAll('[data-wh-gallery]').forEach(function (g) {
  var main = g.querySelector('[data-wh-gallery-main]');
  var thumbs = Array.from(g.querySelectorAll('[data-wh-thumb]'));

  if (!main || thumbs.length < 2) return;

  var touchStartX = 0;
  var touchStartY = 0;

  main.addEventListener(
    'touchstart',
    function (event) {
      if (window.innerWidth >= 750) return;

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    },
    { passive: true }
  );

  main.addEventListener(
    'touchend',
    function (event) {
      if (window.innerWidth >= 750) return;

      var touchEndX = event.changedTouches[0].clientX;
      var touchEndY = event.changedTouches[0].clientY;

      var distanceX = touchEndX - touchStartX;
      var distanceY = touchEndY - touchStartY;

      // Ignore short movements and mostly vertical swipes
      if (Math.abs(distanceX) < 50) return;
      if (Math.abs(distanceX) <= Math.abs(distanceY)) return;

      var currentIndex = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('aria-current') === 'true';
      });

      if (currentIndex === -1) currentIndex = 0;

      // Swipe left: next image
      if (distanceX < 0 && currentIndex < thumbs.length - 1) {
        thumbs[currentIndex + 1].click();
      }

      // Swipe right: previous image
      if (distanceX > 0 && currentIndex > 0) {
        thumbs[currentIndex - 1].click();
      }
    },
    { passive: true }
  );
});

  // Qty
  document.querySelectorAll('[data-wh-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-wh-qty-dec]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change'));
    });
    wrap.querySelector('[data-wh-qty-inc]').addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // Destinations counter
  var band = document.querySelector('[data-wh-destinations]');
  if (band) {
    var chips = band.querySelectorAll('[data-wh-dest]');
    var count = band.querySelector('[data-wh-dest-count]');
    var total = chips.length;
    var msgEl = band.querySelector('[data-wh-dest-msg]');
    var totalEl = band.querySelector('[data-wh-dest-total]');
    if (totalEl) totalEl.textContent = total;
    var selected = 0;
    var updateMsg = function () {
      var m;
      if (selected === 0) m = '47 stops. Your move.';
      else if (selected < 10) m = 'The first stamp is just the beginning!';
      else if (selected <= 20) m = 'Your bottle is becoming a real travel story!';
      else if (selected === total) m = "All 47. You might be the world's most interesting person!";
      else m = "You're living the dream, one destination at a time!";
      if (msgEl) msgEl.textContent = m;
      if (count) count.textContent = selected;
    };
    updateMsg();
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('data-on') === '1';
        chip.setAttribute('data-on', on ? '0' : '1');
        if (on) {
          selected--;
          chip.className = 'inline-flex items-center gap-2 rounded-full border border-navy/10 bg-cream text-navy hover:border-sage hover:bg-sage/30 px-4 py-2 text-sm transition-all';
        } else {
          selected++;
          chip.className = 'inline-flex items-center gap-2 rounded-full border border-sage bg-sage text-navy px-4 py-2 text-sm transition-all';
        }
        updateMsg();
      });
    });
  }

  // Contact form (fake)
  var contact = document.querySelector('[data-wh-contact]');
  if (contact) {
    contact.addEventListener('submit', function (e) {
      e.preventDefault();
      contact.reset();
      var msg = document.querySelector('[data-wh-contact-msg]');
      if (msg) msg.classList.remove('hidden');
    });
  }
})();
